import { Box } from '@hivebrite/design-system/Box';

import { useJobContext } from 'hb-react/frontoffice/apps/JobsV2/contexts/JobContext';
import AttachedFiles from 'hb-react/shared/components/DesignSystem/AttachedFiles';

const Attachments = () => {
  const { uploads } = useJobContext();

  if (!uploads?.length) {
    return null;
  }

  return (
    <Box flexDirection="column">
      <AttachedFiles attachedFiles={uploads} />
    </Box>
  );
};

export default Attachments;
